import React, { useState } from 'react';
import { Control, Controller, FieldError } from 'react-hook-form';
import { Input } from '@/components/ui/input';
import { Button } from '@/components/ui/button';
import { applyInputRules, cn } from '@/utils';
import { Icons } from '@/utils/Icons';

interface CustomInputTwoProps {
  name: string;
  control: Control<any>;
  label?: string;
  required?: boolean;
  type?: string;
  placeholder?: string;
  className?: string;
  labelClassName?: string;
  inputClassName?: string;
  error?: FieldError;
  inputRules?: {
    onlyNumber?: boolean;
    onlyAlphabet?: boolean;
    noSpace?: boolean;
    maxLength?: number;
    minLength?: number;
    pattern?: RegExp;
  };
  [key: string]: any;
}

const CustomInputTwo: React.FC<CustomInputTwoProps> = ({
  name,
  control,
  label,
  required = false,
  type = 'text',
  placeholder,
  className = '',
  labelClassName = 'text-black dark:text-white',
  inputClassName = '',
  inputRules,
  //   error,
  ...props
}) => {
  const [showPassword, setShowPassword] = useState(false);

  const isPassword = type === 'password';
  const inputType = isPassword ? (showPassword ? 'text' : 'password') : type;

  return (
    <div className={`space-y-2 ${className}`}>
      {label && (
        <label htmlFor={name} className={cn('text-sm ', labelClassName)}>
          {label}
          {required && <span className="text-red-500">*</span>}
        </label>
      )}

      <div>
        <Controller
          name={name}
          control={control}
          defaultValue={''}
          render={({ field, fieldState: { error } }) => (
            <>
              <div className="relative">
                <Input
                  id={name}
                  type={inputType}
                  placeholder={placeholder}
                  {...field}
                  {...props}
                  onChange={(e) => {
                    const sanitizedValue = applyInputRules(e.target.value, inputRules);
                    field.onChange(sanitizedValue);
                  }}
                  className={cn(
                    'w-full px-2 rounded-[4px] py-2 border dark:border-[#636173] transition-all duration-200 placeholder:text-[12px] focus:outline-none focus:ring-1 disabled:opacity-50 disabled:cursor-not-allowed dark:bg-[#072C50] dark:text-white',
                    error
                      ? 'border-red-500 focus:border-red-500 focus:ring-red-200'
                      : 'border-black focus:border-gray-400 focus:ring-gray-300',
                    isPassword ? 'pr-10' : '',
                    inputClassName
                  )}
                />
                {/* Password eye toggle */}
                {isPassword && (
                  <Button
                    type="button"
                    variant="ghost"
                    size="sm"
                    className="absolute right-0 top-0 h-full px-3 py-2 !bg-transparent "
                    onClick={() => setShowPassword(!showPassword)}
                  >
                    {showPassword ? (
                      <Icons.openEye className="!h-5 !w-5 text-black/60 dark:text-white" />
                    ) : (
                      <Icons.closeEye className="!h-5 !w-5 text-black/60 dark:text-white" />
                    )}
                  </Button>
                )}
              </div>
              {error && <p className="text-xs text-red-600 mt-1">{error.message}</p>}
            </>
          )}
        />
      </div>
    </div>
  );
};

export default CustomInputTwo;
